import { Menu, ArrowLeftToLine } from "lucide-react";

const TOPICS = [
  "悬疑",
  "运动",
  "科幻",
  "恋爱",
  "喜剧",
  "游戏",
  "历史",
  "音乐",
  "美术",
  "自定义",
];

function GenerationSidebar({
  isCollapsed,
  wordInput,
  wordCount,
  topic,
  customTopic,
  passageLength,
  isGenerating,
  onWordInputChange,
  onTopicChange,
  onCustomTopicChange,
  onPassageLengthChange,
  onGenerate,
  onToggleCollapsed,
}) {
  const isGenerateDisabled =
    isGenerating ||
    wordCount === 0 ||
    (topic === "自定义" && !customTopic.trim());

  return (
    <aside
      className={isCollapsed ? "control-panel is-collapsed" : "control-panel"}
      aria-label="文章生成设置"
    >
      <button
        type="button"
        className="sidebar-menu-button"
        aria-controls="generation-controls"
        aria-expanded={!isCollapsed}
        aria-label={isCollapsed ? "展开生成设置" : "收起生成设置"}
        title={isCollapsed ? "展开生成设置" : "收起生成设置"}
        onClick={onToggleCollapsed}
      >
        {isCollapsed ? (
          <Menu aria-hidden="true" size={21} strokeWidth={2} />
        ) : (
          <ArrowLeftToLine aria-hidden="true" size={21} strokeWidth={2} />
        )}
      </button>

      <div id="generation-controls" hidden={isCollapsed}>
        <div className="panel-heading">
          <p className="section-kicker">CREATE A PASSAGE</p>
          <h1>定制你的阅读材料</h1>
          <p>把要记的词，放进一个真正读得下去的故事里。</p>
        </div>

        <section className="control-section">
          <div className="label-row">
            <label htmlFor="word-list">目标词汇</label>
            <span>{wordCount} 个词</span>
          </div>
          <textarea
            id="word-list"
            value={wordInput}
            rows="6"
            spellCheck="false"
            placeholder={"elusive\nreluctant\nverify"}
            onChange={(event) => onWordInputChange(event.target.value)}
          />
          <p className="field-hint">
            每行输入一个，也可以用逗号或空格分隔，最多 20 个。
          </p>
        </section>

        <section className="control-section">
          <div className="label-row">
            <span id="topic-label">故事主题</span>
            <span>{topic}</span>
          </div>
          <div
            className="topic-grid"
            role="group"
            aria-labelledby="topic-label"
          >
            {TOPICS.map((item) => (
              <button
                type="button"
                className={
                  topic === item ? "topic-option selected" : "topic-option"
                }
                aria-pressed={topic === item}
                key={item}
                onClick={() => onTopicChange(item)}
              >
                {item}
              </button>
            ))}
          </div>
          {topic === "自定义" && (
            <input
              className="custom-topic"
              value={customTopic}
              placeholder="输入你感兴趣的主题"
              aria-label="自定义主题"
              onChange={(event) => onCustomTopicChange(event.target.value)}
            />
          )}
        </section>

        <section className="control-section length-control">
          <div className="label-row">
            <label htmlFor="passage-length">文章长度</label>
            <output htmlFor="passage-length">{passageLength} 词</output>
          </div>
          <input
            id="passage-length"
            type="range"
            min="200"
            max="800"
            step="50"
            value={passageLength}
            style={{
              "--range-progress": `${((passageLength - 200) / 600) * 100}%`,
            }}
            onChange={(event) =>
              onPassageLengthChange(Number(event.target.value))
            }
          />
          <div className="range-labels" aria-hidden="true">
            <span>短篇 200</span>
            <span>长篇 800</span>
          </div>
        </section>

        <button
          type="button"
          className="generate-button"
          disabled={isGenerateDisabled}
          onClick={onGenerate}
        >
          <span>{isGenerating ? "正在生成..." : "生成新文章"}</span>
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </aside>
  );
}

export default GenerationSidebar;
